import { useLocationConfigContext } from "../../context/LocationConfigContext";
import { EstablishmentTable } from "./components/EstablishmentsTable";
import CRUDSectorModal from "../sectortab/CRUDSectorModal";
import { useEffect, useMemo, useState } from "react";
import { ETypeOfNotification, Modal, setNotification } from "medere-ui-framework";
import { Button } from "primereact/button";
import { deleteEstablishment, loadAllEstablishments, saveSector } from "../../../../servicesHooks/Location/useLocationConfigService";
import { Establishment, Sector } from "../../../../interface/interface";
import { useDispatch } from "react-redux";

export default function EstablishmentsView() {
    const { establishments, setEstablishments, setCallersToEstablishments, setTotemList, setRoomsToEstablishments, setBedsToEstablishments } = useLocationConfigContext();
    const dispatch = useDispatch()

    const [openSectorModal, setOpenSectorModal] = useState(false); //abre o cierra la modal de sector
    const [sectorToEdit, setSectorToEdit] = useState<Sector | null>(null);

    const [openRemoveModal, setOpenRemoveModal] = useState(false);
    const [indexToRemove, setIndexToRemove] = useState<number | null>(null);

    useEffect(() => {//Poner en metodo refresh para usar cuando se guarda un establecimiento
        if (establishments?.length === 0) {       //Si ya hay algo cargado, no cargo. Esto para que no se ejecute por cada vez que entra a la tab
            loadAllEstablishments().then((res) => {
                
                setEstablishments(res);
                setCallersToEstablishments(res);
                setTotemList()
            }).catch((err) => {
                console.error(err)
                dispatch(setNotification({ title: "Ocurrió un error", desc: 'No se pudieron cargar los establecimientos', icon: 'pi-times', typeOfNotification: ETypeOfNotification.ERROR }));
            });
        }
    }, [])

    const establishmentIdsKey = useMemo(
        () => (establishments ?? []).map((est) => est.buildingid).sort((a, b) => a - b).join(","),
        [establishments]
    );

    useEffect(() => {
        if (!establishmentIdsKey) return;
        void (async () => {
            await setRoomsToEstablishments();
            await setBedsToEstablishments();
        })();
    }, [establishmentIdsKey]);

    const updateEstablishments = (ests: Establishment[]) => { //Actualiza la lista auxiliar en la real
        setEstablishments(ests);
    };

    const handleAddSector = (est: Establishment) => {
        setSectorToEdit({
            sector: 0,
            name: "",
            sectortype: 0,
            sectortypedescription: "",
            externalcode: "",
            repositorytype: 0,
            repositorytypedescription: "",
            parentsector: 0,
            parentsectorname: "",
            shortname: "",
            acceptpatienttransfers: false,
            restrictroomgendercontrol: true,
            prescriptionpriority: null,
            active: true,
            building: est.buildingid,
            buildigname: est.buildingname ?? ""
        });
        setOpenSectorModal(true);
    };

    const handleOpenRemoveModal = (idxToRemove: number) => {
        setIndexToRemove(idxToRemove)
        setOpenRemoveModal(true)
    }
    
    const handleDelete = async (index: number) => {
        await deleteEstablishment(establishments[index].buildingid)
        .then(() => {
            const updated = establishments.filter((_, i) => i !== index);
            updateEstablishments(updated);
            setOpenRemoveModal(false);
            dispatch(setNotification({
                title: "Eliminado",
                desc: "Se eliminó el establecimiento",
                icon: "pi pi-check-circle",
                typeOfNotification: ETypeOfNotification.INFO
            }));
        }).catch((err) => {
            console.error(err)
            if (err.response?.status === 409) {
                if (err.response?.data === 'ASSOCIATED')
                    dispatch(setNotification({ title: "No se puede eliminar", desc: "El establecimiento tiene elementos asociados.", icon: 'pi-exclamation-triangle', typeOfNotification: ETypeOfNotification.WARNING }));
            } else
                dispatch(setNotification({ title: "Error", desc: "No se pudo eliminar el establecimiento", icon: "pi pi-times", typeOfNotification: ETypeOfNotification.ERROR }));
        });
    };

    const handleSaveSector = async (newSector: Sector, estId: number) => { //Se ejecuta al confirmar los datos del sector centinela de la CRUDModal
        await saveSector(newSector)
        .then(() => {
            loadAllEstablishments().then((res) => {
                setEstablishments(res);
                setCallersToEstablishments(res);
            }).catch((err) => {
                console.error(err)
                dispatch(setNotification({ title: "Ocurrió un error", desc: 'No se pudieron cargar los datos', icon: 'pi-times', typeOfNotification: ETypeOfNotification.ERROR }));
            });
        });;

        setOpenSectorModal(false);
    };

    return (
        <div>
            <h1 className="title2">Establecimiento</h1>
            <div className="flex flex-row justify-content-between emr-border-bottom pb-2">
                <p className="grey-color">Se crean para poder asociar sectores, consultorios y puestos de atención en cada edificio.</p>
            </div>
            <EstablishmentTable establishments={establishments} onChange={(newEstablishments) => updateEstablishments(newEstablishments)} createSector={(establishment) => handleAddSector(establishment)} onDelete={(idx) => handleOpenRemoveModal(idx)}/>

            {openSectorModal && (
                <CRUDSectorModal
                visible={openSectorModal}
                setVisible={setOpenSectorModal}
                onSubmit={handleSaveSector}
                sectorToEdit={sectorToEdit}
                isCreateModeFromEstablishment={true}
                />
            )}

            <Modal className="location-mobile-editor-modal" visible={openRemoveModal} setVisible={setOpenRemoveModal} header={"Estás por eliminar el establecimiento"} headerStyle={{ fontSize: '12px', textAlign: 'center' }} width='w-medium' closable={false}>
                <div>
                    <p className="grey-color">No podrás eliminar establecimientos que tengan asociados sectores.</p>
                    <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <Button id="buttonDeleteId" label="Si, eliminar" onClick={() => indexToRemove !== null && handleDelete(indexToRemove)} className="w-full buttonMain" />
                        <Button id="buttonCancelDeleteId" label={"Cancelar"} onClick={() => setOpenRemoveModal(false)} className="w-full btnCancel2" />
                    </div>
                </div>
            </Modal>
        </div>
    )
}

